<div class="modal-dialog modal-xl" [ngClass]="{ 'modal-content': action != 'update_promo' }">
    <div *ngIf="action != 'update_promo'" class="modal-header">
        <div><h2 class="modal-title" *ngIf="action == 'create_promo'">Create new Promotion</h2>
            <h2 class="modal-title" *ngIf="action == 'delete_promo'">Delete  Promotion «{{rowInfos['promo_name']}}»</h2>
        </div>
    </div>
    <div class="modal-body">
         <div *ngIf="action != 'delete_promo'" fxLayout="row" fxLayout.xs="column">
            <div fxFlex="33.33%" style="padding: 0 10px 0 10px;">
                <div fxLayout="row" style="padding-top: 15px;" class="element-style">
                    <div class="label-style" fxFlex="30%">Name</div>
                    <div fxFlex="70%">
                        <input class="col-input" [formControl]="promoNameControl" placeholder="Name" style="margin: 0;">
                    </div>
                </div>
                <div fxLayout="row" style="padding-top: 15px;" class="element-style">
                    <div class="label-style" fxFlex="30%">Product</div>
                    <div fxFlex="70%">
                        <mat-select placeholder="Product" [formControl]="productControl" (selectionChange)="updateDetail()">
                            <mat-option [value]="element['id']" *ngFor="let element of productData; let i = index">{{element['name']}} - {{element['price_label']}}</mat-option>
                        </mat-select>
                    </div>
                </div>
                <div fxLayout="row" style="padding-top: 15px;" class="element-style">
                    <div class="label-style" fxFlex="30%">Type</div>
                    <div fxFlex="70%">
                        <mat-select placeholder="Type" [formControl]="typeControl" (selectionChange)="updatePromotype()">
                            <mat-option [value]="'prime_sponsor'">Prime Sponsor</mat-option>
                            <mat-option [value]="'promotion'">Promotion</mat-option>
                        </mat-select>
                    </div>
                </div>
                <div *ngIf="promoType == 'classic'" fxLayout="row" class="element-style">
                    <div class="label-style" fxFlex="30%">Nb Months</div>
                    <div fxFlex="70%">
                        <input class="col-input" [formControl]="durationControl" placeholder="Duration" style="margin: 0;">
                    </div>
                </div>
            </div>
            <div fxFlex="33.33%" style="padding: 0 10px 0 10px;">
                <div *ngIf="promoType == 'classic'" fxLayout="row" class="element-style">
                    <div class="label-style" fxFlex="30%">Price</div>
                    <div fxFlex="70%">
                        <input class="col-input" [formControl]="priceControl" placeholder="Price" style="margin: 0;">
                    </div>
                </div>
                <div *ngIf="promoType != 'classic'" fxLayout="row" class="element-style">
                    <div class="label-style" fxFlex="30%">% Dicount Price</div>
                    <div fxFlex="70%">
                        <input class="col-input" [formControl]="priceRateControl" placeholder="%" style="margin: 0;" (change)="updateDetail()">
                    </div>
                </div>
                <div *ngIf="promoType != 'classic'" fxLayout="row" class="element-style">
                    <div class="label-style" fxFlex="30%">Active Period</div>
                    <div fxFlex="70%">
                        <div class="date-input">
                            <mat-date-range-input [rangePicker]="picker">
                                <input matStartDate [formControl]="beginDateControl" placeholder="Start">
                                <input matEndDate [formControl]="expirationDateControl" placeholder="End">
                            </mat-date-range-input>
                            <mat-icon matDatepickerToggleIcon fontIcon="close_small" style="font-size: 18px; display: flex; align-items: center;" (click)="resetDate()"></mat-icon>
                            <mat-datepicker-toggle [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </div>
                    </div>
                </div>
                <div *ngIf="promoType != 'classic'" fxLayout="row" class="element-style">
                    <div class="label-style" fxFlex="30%">Active</div>
                    <div fxFlex="70%">
                        <mat-select placeholder="Active" [formControl]="activeControl">
                            <mat-option [value]="false">False</mat-option>
                            <mat-option [value]="true">True</mat-option>
                        </mat-select>
                    </div>
                </div>
            </div>
            <div *ngIf="['prime_sponsor', 'promotion'].includes(promoType)" fxFlex="33.33%" style="padding: 0 10px 0 10px;">
                <div fxLayout="row" class="element-style">
                    <div class="label-style" fxFlex="30%">Promoter</div>
                    <div fxFlex="70%">
                        <mat-select placeholder="Promoter" [formControl]="promoterControl">
                            <mat-option [value]="result['id']" *ngFor="let result of promoterData; let i = index">{{result['promo_code']}}: {{result['first_name']}} {{result['last_name']}} ({{result['email']}})</mat-option>
                        </mat-select>
                    </div>
                </div>
                <div fxLayout="row" class="element-style">
                    <div class="label-style" fxFlex="30%">% Promoter Gain</div>
                    <div fxFlex="70%">
                        <input class="col-input" [formControl]="promoterRateControl" placeholder="%" style="margin: 0;" (change)="updateDetail()">
                    </div>
                </div>
            </div>
        </div>
        <div style="padding-top: 15px;"></div>
        <div *ngIf="action == 'update_promo'" fxLayoutAlign="center center">
            <div>
                <div><strong>Details de la Promo</strong></div>
                <table>
                    <tbody>
                        <tr>
                            <td style="padding: 8px; border: 1px solid #ddd; color:#1D6E57;">Code Promo :</td>
                            <td style="padding: 8px; border: 1px solid #ddd; text-align:center;">{{promoCode}}</td>
                        </tr>
                        <tr>
                            <td style="padding: 8px; border: 1px solid #ddd; color:#FF7F50;">Product Price :</td>
                            <td style="padding: 8px; border: 1px solid #ddd; text-align:center;">XOF {{priceProduct}}</td>
                        </tr>
                        <tr>
                            <td style="padding: 8px; border: 1px solid #ddd; color:#FF7F50;">Student Payment (- {{priceRate}}%) :</td>
                            <td style="padding: 8px; border: 1px solid #ddd; text-align:center;">XOF {{studentPayment}}</td>
                        </tr>
                        <tr>
                            <td style="padding: 8px; border: 1px solid #ddd; color:#DAA520;">Promoter Payout ({{promoterRate}}%) :</td>
                            <td style="padding: 8px; border: 1px solid #ddd; text-align:center;">XOF {{promoterPayout}}</td>
                        </tr>
                        <tr>
                            <td style="padding: 8px; border: 1px solid #ddd; color:#2E8B57;">Profit :</td>
                            <td style="padding: 8px; border: 1px solid #ddd; text-align:center;">XOF {{enovskyGain}}</td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
        <div style="padding-top: 15px;"></div>
        <div *ngIf="action == 'delete_promo'">You are about to delete this promotion. Continue ?</div>
        <div *ngIf="action == 'update_promo'">
            <div fxLayoutAlign="center center">
                <div *ngIf="promoType == 'prime_sponsor'" fxFlex="20%" class="label-style" fxLayoutAlign="center center">
                    <input class="form-check-input" style="font-size:large; cursor: pointer; " type="checkbox" role="switch" [formControl]="sendEmailControl">
                    <span>Send Email to Promoter</span>
                </div>
                <button class="button-validate-small" (click) = "applyAction()">Validate</button>
            </div>
        </div>
        <div *ngIf="action == 'delete_promo' || action == 'create_promo'">
            <hr>
            <div class="modal-footer" style="margin-top: 5px;">
                <div *ngIf="promoType == 'prime_sponsor'" class="label-style" fxLayoutAlign="center center">
                    <input class="form-check-input" style="font-size:large; cursor: pointer; " type="checkbox" role="switch" [formControl]="sendEmailControl">
                    <span>Send Email to Promoter</span>
                </div>
                <button type="button" class="button-secondary-small left-side" (click)="closeWindow()">Close</button>
                <button type="button" class="button-validate-small" (click)="applyAction()" style="margin-right: 8px;">Validate</button>
            </div>
        </div>
    </div>
</div>